import React from "react";
import {
  Layout,
  ContentHolder,
  PopupDialog,
} from "@app/components/commonStyles";
import { LargeLeaf, SmallLeaf } from "@app/assets";
type Props = {
  children: any;
  className?: string;
  classname?: string;
  ref?:any;
  classRoomLayout?: boolean;
};

export default function MainLayout({
  children,
  className = "",
  classname = "form-container",
  classRoomLayout = false,
  ref
}: Props) {
  return (
    <Layout ref={ref}>
      <ContentHolder className={className}>
        <PopupDialog className={classRoomLayout ? classname + " max-w-1040" : classname}>
          {children}
          <img alt="" className="top-left-image" src={SmallLeaf} />
        </PopupDialog>
      </ContentHolder>
      <img alt="" className="bottom-right-image" src={LargeLeaf} />
    </Layout>
  );
}
